export enum ListSourceType {
  LIST_SPOTLIGHT = 'list-spotlight', // list opened through spotlight item
  LIST_EMAIL = 'list-email', // list opened through email link
  LIST_FOLLOW_UP_EMAIL = 'list-follow-up-email', // list opened through follow up email link
  LIST_LOCAL = 'list-local', // list opened through direct link, own list selection, DEFAULT FALLBACK value
  LIST_DASHBOARD = 'list-dashboard', // list opened from best performance list dashboard
  LIST_MODAL = 'list-modal', // list opened through modal promotion
  LIST_STORY_NAVIGATION = 'list-story-navigation', // Landing page stories navigation
  LIST_STORY_PAGE = 'list-story-page', // Landing page stories
  LIST_SECONDARY_NAVIGATION = 'list-secondary-navigation', // Landing page secondary navigation bar link with list
  LIST_LANDING_PAGE = 'list-landing-page', // Landing page list link
  LIST_LANDING_PAGE_NEWS_FEED = 'list-landing-page-news-feed', // List opened from LP news feed article
  LIST_LANDING_PAGE_PROMOTION = 'list-landing-page-promotion', // list opened through LP promotion (Fancy list)
}

export enum BasketItemSource {
  EMPTY = '',
  SEARCH = 'search',
  SEARCH_SUGGEST_PRODUCT = 'search-suggest-product',
  SEARCH_SUGGEST_FILTER = 'search-suggest-filter',
  SEARCH_SUGGEST_AUTOCOMPLETE = 'search-suggest-autocomplete',

  // Landing page stories:
  SEARCH_STORY_NAVIGATION = 'search-story-navigation',
  LIST_STORY_NAVIGATION = ListSourceType.LIST_STORY_NAVIGATION,
  SEARCH_STORY_PAGE = 'search-story-page',
  LIST_STORY_PAGE = ListSourceType.LIST_STORY_PAGE,

  // when CS opens on basket page
  BASKET = 'basket',

  // Landing page classic:
  SEARCH_SECONDARY_NAVIGATION = 'search-secondary-navigation',
  LIST_SECONDARY_NAVIGATION = ListSourceType.LIST_SECONDARY_NAVIGATION,
  SEARCH_LANDING_PAGE = 'search-landing-page',
  LIST_LANDING_PAGE = ListSourceType.LIST_LANDING_PAGE,
  LIST_LANDING_PAGE_NEWS_FEED = ListSourceType.LIST_LANDING_PAGE_NEWS_FEED,
  LIST_LANDING_PAGE_PROMOTION = ListSourceType.LIST_LANDING_PAGE_PROMOTION,

  RECOMMENDATION_PANEL = 'recommendation-panel',

  BRACKETS_PCARD = 'brackets-pcard',
  PERFORMANCE_WIDGET = 'performance-widget',

  BULK_AGREEMENT = 'bulk-agreement',

  BOARD = 'board',

  // List sources
  LIST_SPOTLIGHT = ListSourceType.LIST_SPOTLIGHT,
  LIST_EMAIL = ListSourceType.LIST_EMAIL,
  LIST_FOLLOW_UP_EMAIL = ListSourceType.LIST_FOLLOW_UP_EMAIL,
  LIST_LOCAL = ListSourceType.LIST_LOCAL,
  LIST_DASHBOARD = ListSourceType.LIST_DASHBOARD,
  LIST_MODAL = ListSourceType.LIST_MODAL,
}
